import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppContext } from 'src/context/AppContext';
import Cooladata from 'src/components/common/Cooladata';
import Credits from 'src/components/common/Credits';

import heroImg from './assets/hero.svg';
import { Footer } from './Footer';
import { HeroStats } from './HeroStats';
import { LifeTime } from './LifeTime';
import { Wars } from './Wars';
import { getPersonalStats, parseBirthDateParam } from './utils';

import css from './Result.module.scss';
import Head from 'src/components/common/Head';
import { OG } from 'src/constants/other';

export const Result = () => {
  const [searchParams] = useSearchParams();
  const birthDateParam = searchParams.get('d');
  const { personalStats, setPersonalStats } = useAppContext();

  useEffect(() => {
    const birthdate = parseBirthDateParam(birthDateParam);

    if (birthdate) {
      setPersonalStats(getPersonalStats(birthdate));
    }
  }, [birthDateParam, setPersonalStats]);

  if (!personalStats) {
    return null;
  }

  return (
    <>
      <Head
        og={{
          title: OG.resultsPage.title(personalStats.stats.percentage),
          description: OG.resultsPage.description,
        }}
      />
      <Cooladata pageId="results" />
      <div className={css.result}>
        <div className={css.hero}>
          <img className={css.heroImg} src={heroImg} alt="" />
          <div className={css.heroContent}>
            <HeroStats />
          </div>
        </div>

        <div className={css.sections}>
          <LifeTime />
          <Wars />
          <Footer />
        </div>
        <Credits />
      </div>
    </>
  );
};
